var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import React, { useEffect, useState } from "react";
import EdButton, { EdButtonIcon, } from "@frameworks/web/components/generic/edbutton/edButton";
import GenericTooltip from "@frameworks/web/components/generic/GenericTooltip";
import GenericTooltipInnerContent from "@frameworks/shared-library/components/GenericTooltipInnerContent";
import { addCommasWithoutDecimal, roundUpToTwoDecimalPlaces, } from "@domains/utils/numberMethods";
import ShareSocialLinks from "@frameworks/shared-library/components/Generic/shareSocialLinks/shareSocialLinks";
import { useNavigate } from "react-router-dom";
import OfferingsTableCheckboxActions from "../Offerings/Generic/OfferingsTableCheckboxActions/OfferingsTableCheckboxActions";
import Search from "@frameworks/shared-library/components/Search/search";
import { SearchAssetTypeEnum } from "@frameworks/shared-library/components/Search/constant";
import config from "@frameworks/web/config/domain";
import OfferingsComparison from "@frameworks/shared-library/components/Offerings/Generic/OfferingsComparison/OfferingsComparison";
import GenericPopup from "@frameworks/shared-library/components/GenericPopup";
import OfferingsColumnFilters from "@frameworks/shared-library/components/Offerings/Generic/OfferingsColumnFilters/OfferingsColumnFilters";
import DynamicPagination from "@frameworks/shared-library/components/Pagination/Pagination";
import "@frameworks/shared-library/stylesheets/components/Offerings/Generic/OfferingsTable.scss";
import OfferingsCheckboxListFilters from "@frameworks/shared-library/components/Offerings/Generic/GenericFilterSort/OfferingsCheckboxListFilters/OfferingsCheckboxListFilters";
import newTag from "@frameworks/shared-library/assets/images/markets/newTag.svg";
import featuredTag from "@frameworks/shared-library/assets/images/markets/featuredTag.svg";
import { ESortOrder, } from "@domains/features/Markets/MutualFunds/dto/MutualFundsSchemesDTO";
import OfferingsRangeFilters from "@frameworks/shared-library/components/Offerings/Generic/GenericFilterSort/OfferingsRangeFilters/OfferingsRangeFilters";
import GenericTableShimmer from "@frameworks/shared-library/components/GenericTableShimmer/GenericTableShimmer";
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
import { EInvestmentType } from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFundConstant";
import mutualFundDi from "@mainDi/features/mutualFund/servicelocator";
import { Spinner } from "react-bootstrap";
import configUrl from "@frameworks/salesjourney/config/domain";
import RedeemSidebarFlow from "./RedeemSidebarFlow";
import bookmarkFlyImage from "@frameworks/shared-library/assets/images/SalesJourney/bookmarkFly.svg";
export var EComponentFlow;
(function (EComponentFlow) {
    EComponentFlow["PRODUCT_BOUQUET"] = "PRODUCT_BOUQUET";
    EComponentFlow["SAVED_PRODUCT"] = "SAVED_PRODUCT";
})(EComponentFlow || (EComponentFlow = {}));
export var defaultActiveColumnFilers = {
    currentActiveColumnFilter: "",
    filtersList: [],
};
var EProductBouquetKebabMenuItems;
(function (EProductBouquetKebabMenuItems) {
    EProductBouquetKebabMenuItems["START_SWP"] = "Start SWP";
    EProductBouquetKebabMenuItems["START_STP"] = "Start STP";
    EProductBouquetKebabMenuItems["START_SIP"] = "Start SIP";
    EProductBouquetKebabMenuItems["START_LUMPSUM"] = "Start Lumpsum";
    EProductBouquetKebabMenuItems["REDEEM"] = "Redeem";
    EProductBouquetKebabMenuItems["SWITCH_FUND"] = "Switch Fund";
})(EProductBouquetKebabMenuItems || (EProductBouquetKebabMenuItems = {}));
var menuItemsToInvestmentTypeMapping = (_a = {},
    _a[EProductBouquetKebabMenuItems.START_SWP] = EInvestmentType.SWP,
    _a[EProductBouquetKebabMenuItems.START_STP] = EInvestmentType.STP,
    _a[EProductBouquetKebabMenuItems.START_SIP] = EInvestmentType.SIP,
    _a[EProductBouquetKebabMenuItems.START_LUMPSUM] = EInvestmentType.LUMPSUM,
    _a[EProductBouquetKebabMenuItems.REDEEM] = EInvestmentType.REDEEM,
    _a[EProductBouquetKebabMenuItems.SWITCH_FUND] = EInvestmentType.SWITCH,
    _a);
export var mutualFundsActions = [
    {
        icon: "edel-icon-redeem",
        text: EProductBouquetKebabMenuItems.START_LUMPSUM,
    },
    {
        icon: "edel-icon-withdrawal",
        text: EProductBouquetKebabMenuItems.START_SIP,
    },
    {
        icon: "edel-icon-rupee-download",
        text: EProductBouquetKebabMenuItems.REDEEM,
    },
    {
        icon: "edel-icon-calendar-down-arrow",
        text: EProductBouquetKebabMenuItems.START_SWP,
    },
    {
        icon: "edel-icon-transfer",
        text: EProductBouquetKebabMenuItems.START_STP,
    },
    {
        icon: "edel-icon-switch-fund-3",
        text: EProductBouquetKebabMenuItems.SWITCH_FUND,
    },
];
var getSchemeValue = function (schemeValuesArr, schemeKeysArr, schemeKey) {
    var _a;
    return (_a = schemeValuesArr[schemeKeysArr.indexOf(schemeKey)]) !== null && _a !== void 0 ? _a : "";
};
var getTagDetails = {
    isNew: {
        text: "New",
        icon: React.createElement("i", { className: "icon edel-icon-glossy" }),
        className: "icon-text-container bg_frosted-aqua txt_ocean-whisper",
    },
    isFeatured: {
        text: "Featured",
        icon: React.createElement("i", { className: "icon edel-icon-crown" }),
        className: "icon-text-container bg_candy-pink txt_dark-purple",
    },
};
var TopFundsTableDesk = function (props) {
    var _a, _b, _c, _d;
    var navigate = useNavigate();
    var _e = __read(useState(), 2), isin = _e[0], setIsin = _e[1];
    var _f = __read(useState(false), 2), searchPop = _f[0], setSearchPop = _f[1];
    var _g = __read(useState([]), 2), checked = _g[0], setChecked = _g[1];
    var _h = __read(useState([]), 2), currentItem = _h[0], setCurrentItem = _h[1];
    var _j = __read(useState(false), 2), showShareModal = _j[0], setshowShareModal = _j[1];
    var _k = __read(React.useState(false), 2), isShowMFCompareFooter = _k[0], setIsShowMFCompareFooter = _k[1];
    var _l = __read(React.useState(defaultActiveColumnFilers), 2), currentActiveColumnFilterConfig = _l[0], setCurrentActiveColumnFilterConfig = _l[1];
    var _m = __read(useState(), 2), sharelinks = _m[0], setSharelinks = _m[1];
    var _o = __read(useState(false), 2), showCtaLoader = _o[0], setShowCtaLoader = _o[1];
    var tableRef = React.useRef(null);
    var _p = __read(useState(), 2), kebabMenuItems = _p[0], setKebabMenuItems = _p[1];
    var _q = __read(useState(false), 2), openSidebar = _q[0], setOpenSidebar = _q[1];
    var _r = __read(useState(null), 2), selectedSchemeData = _r[0], setSelectedSchemeData = _r[1];
    var _s = __read(useState(null), 2), transactionType = _s[0], setTransactionType = _s[1];
    var _t = __read(useState(false), 2), flying = _t[0], setFlying = _t[1];
    useEffect(function () {
        var sidebarDiv = document.querySelector(".collapsed-sidebar");
        if (showShareModal) {
            sidebarDiv === null || sidebarDiv === void 0 ? void 0 : sidebarDiv.classList.add("low-index");
        }
        return function () {
            sidebarDiv === null || sidebarDiv === void 0 ? void 0 : sidebarDiv.classList.remove("low-index");
        };
    }, [showShareModal]);
    var onSortToggleClick = function (item) {
        props.mutualFundFilterSortValues["sortColumn"] =
            item.key3 === "Name" ? (item.type ? item.key3 : "NameDSC") : item.key3;
        props.mutualFundFilterSortValues["sortOrder"] = item.type
            ? ESortOrder.ASCENDING
            : ESortOrder.DESCENDING;
        props.onFilterSelectionCallback(__assign({}, props.mutualFundFilterSortValues), true);
    };
    var onDropDownChange = function (data, param) {
        var _a;
        props.onFilterSelectionCallback(__assign(__assign({}, props.mutualFundFilterSortValues), (_a = {}, _a[param] = __assign(__assign({}, data.value), { value: "" }), _a)));
    };
    var onInputFormChange = function (name, vale, param) {
        var _a;
        props.onFilterSelectionCallback(__assign(__assign({}, props.mutualFundFilterSortValues), (_a = {}, _a[param] = __assign(__assign({}, props.mutualFundFilterSortValues[param]), { value: vale }), _a)));
    };
    var onCheckBoxChange = function (data, param) {
        props.mutualFundFilterSortValues[param] = Object === null || Object === void 0 ? void 0 : Object.keys(data[param]).map(function (item) {
            return data[param][item].filterValue;
        });
        !!(props === null || props === void 0 ? void 0 : props.handleUpdateSelectedFiltersState) &&
            props.handleUpdateSelectedFiltersState(data);
        !!(props === null || props === void 0 ? void 0 : props.onFilterSelectionCallback) &&
            props.onFilterSelectionCallback(__assign({}, props.mutualFundFilterSortValues));
    };
    var generateColumnFilterPopupChildren = function (keyName) {
        switch (keyName) {
            case "rating":
                return (React.createElement(OfferingsCheckboxListFilters, { displayDataList: currentActiveColumnFilterConfig.filtersList, onChangeCallback: function (data) { return onCheckBoxChange(data, "rating"); }, selectedValuesList: props === null || props === void 0 ? void 0 : props.selectedFiltersData, parentKeyName: keyName, parentClassName: "rating-columns-filter" }));
            case "year1":
                return (React.createElement(OfferingsRangeFilters, { typeOfFilter: "year1", onDropDownChange: onDropDownChange, onInputFormChange: onInputFormChange, mutualFundFilterSortValues: props.mutualFundFilterSortValues, errorData: props === null || props === void 0 ? void 0 : props.filterFieldsErrors }));
            case "year3":
                return (React.createElement(OfferingsRangeFilters, { typeOfFilter: "year3", onDropDownChange: onDropDownChange, onInputFormChange: onInputFormChange, mutualFundFilterSortValues: props.mutualFundFilterSortValues, errorData: props === null || props === void 0 ? void 0 : props.filterFieldsErrors }));
            case "year5":
                return (React.createElement(OfferingsRangeFilters, { typeOfFilter: "year5", onDropDownChange: onDropDownChange, onInputFormChange: onInputFormChange, mutualFundFilterSortValues: props.mutualFundFilterSortValues, errorData: props === null || props === void 0 ? void 0 : props.filterFieldsErrors }));
            case "fundSize":
                return (React.createElement(OfferingsRangeFilters, { typeOfFilter: "fundSize", onDropDownChange: onDropDownChange, onInputFormChange: onInputFormChange, mutualFundFilterSortValues: props.mutualFundFilterSortValues, errorData: props === null || props === void 0 ? void 0 : props.filterFieldsErrors, inputLimit: 14 }));
            case "expenseRatio":
                return (React.createElement(OfferingsRangeFilters, { typeOfFilter: "expenseRatio", onDropDownChange: onDropDownChange, onInputFormChange: onInputFormChange, mutualFundFilterSortValues: props.mutualFundFilterSortValues, errorData: props === null || props === void 0 ? void 0 : props.filterFieldsErrors }));
            default:
                return React.createElement(React.Fragment, null);
        }
    };
    var checkIfFilterIsAppliedForTableColumn = function (keyName) {
        var flag = false;
        if (props.mutualFundFilterSortValues) {
            var valueInState = props.mutualFundFilterSortValues[keyName];
            if ((typeof valueInState === "string" ||
                typeof valueInState === "number") &&
                !!valueInState)
                flag = true;
            if (typeof valueInState === "object" &&
                !Array.isArray(valueInState) &&
                !!valueInState)
                flag = true;
            if (Array.isArray(valueInState) && valueInState.length)
                flag = true;
            return flag;
        }
    };
    var generateTableColumnName = function (name, keyName) {
        return (React.createElement("div", { className: "primary-column-filter-container DMSanM_14_500 d-flex align-items-center gap-2 ".concat((!!currentActiveColumnFilterConfig.currentActiveColumnFilter &&
                currentActiveColumnFilterConfig.currentActiveColumnFilter ===
                    keyName) ||
                checkIfFilterIsAppliedForTableColumn(keyName)
                ? "active-column-filter"
                : "") },
            props.mutualFundFilterSortValues && (React.createElement(GenericPopup, { isShow: keyName ===
                    currentActiveColumnFilterConfig.currentActiveColumnFilter, setIsShow: function () {
                    handleUpdateCurrentActiveColumnFilter(keyName !==
                        currentActiveColumnFilterConfig.currentActiveColumnFilter
                        ? keyName
                        : "");
                    props.handleCancelApplyingFiltersCallback();
                }, children: React.createElement(OfferingsColumnFilters, { parentClassName: "checkboxes-filters", internalFilterChildren: generateColumnFilterPopupChildren(keyName), applyCallback: function () {
                        if (!props.filterFieldsErrors) {
                            handleUpdateCurrentActiveColumnFilter("");
                        }
                        props.handleApplyFilterCallback();
                    }, cancelCallback: function () {
                        !!(props === null || props === void 0 ? void 0 : props.handleCancelApplyingFiltersCallback) &&
                            props.handleCancelApplyingFiltersCallback();
                        handleUpdateCurrentActiveColumnFilter("");
                    }, clearAllCallback: function () {
                        handleUpdateCurrentActiveColumnFilter("");
                        (props === null || props === void 0 ? void 0 : props.handleClearSpecificFilter) &&
                            props.handleClearSpecificFilter(keyName);
                    } }), placement: "bottom-start", onClose: function () {
                    return setCurrentActiveColumnFilterConfig({
                        currentActiveColumnFilter: "",
                        filtersList: [],
                    });
                }, button: React.createElement("span", { className: "column-filter-icon-container d-flex align-items-center justify-content-center hand_cursor" },
                    React.createElement("i", { className: "edel-icon-curved-filter" })), parentClass: "offerings-dropdown-container border-0", buttonOnClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    handleUpdateCurrentActiveColumnFilter(keyName);
                }, containerDom: function () { return document.getElementById(keyName); }, isHeadline: true, removeTooltipArrow: true })),
            React.createElement("span", null, name)));
    };
    var yearValue = function (key, key2) {
        return (React.createElement("div", { className: "RobotoM_15_400 text-end txt-grey-shade1" }, Number(key) ? "".concat(key, "%") : "-"));
    };
    var generateSchemeName = function (keys, keysForCustomFunction) {
        var tagDetails = {};
        var isNewScheme = getSchemeValue(keys, keysForCustomFunction, "isNew") === "t";
        var isFeaturedScheme = getSchemeValue(keys, keysForCustomFunction, "isFeatured") === "t";
        if (isFeaturedScheme) {
            tagDetails = getTagDetails.isFeatured;
        }
        else if (isNewScheme) {
            tagDetails = getTagDetails.isNew;
        }
        var generateWidthForCalc = function () {
            var maxWidth = 0;
            if (isFeaturedScheme) {
                maxWidth = 85;
            }
            if (isNewScheme) {
                maxWidth = 85;
            }
            if (isFeaturedScheme && isNewScheme) {
                maxWidth = 155;
            }
            return "calc(100% - ".concat(maxWidth, "px)");
        };
        var searchText = props.mutualFundFilterSortValues["searchText"];
        var escapeRegExp = function (string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        };
        var highlightMatch = function (text, query) {
            if (!query)
                return text;
            var escapedQuery = escapeRegExp(query);
            var parts = text.split(new RegExp("(".concat(escapedQuery, ")"), "gi"));
            return parts.map(function (part, index) {
                return part.toLowerCase() === query.toLowerCase() ? (React.createElement("strong", { key: index }, part)) : (part);
            });
        };
        return (React.createElement("div", { className: "d-flex align-item-center gap-2 position-relative" },
            React.createElement("div", { className: "read-more-tooltip align-items-center flex-1" },
                React.createElement(GenericSchemeName, { name: keys[0], schemeName: highlightMatch(keys[0], searchText), subText1: keys[1], subText2: keys[2], maxWidth: 100, maxWidthUnit: "%", image: keys[7], tooltipClassName: "scheme-name-tooltip", showTooltip: true, showImage: true, parentClassName: "text-start w-100", subTextMaxWidth: generateWidthForCalc(), highlightSchemeNameOnHover: true })),
            (isNewScheme || isFeaturedScheme) && (React.createElement("div", { className: "flex-column new-or-featured-tag-container position-absolute bottom-0 end-0" },
                isNewScheme && (React.createElement("img", { className: "mgl-5 mgb-3", src: newTag, alt: "New Scheme" })),
                isFeaturedScheme && (React.createElement("img", { className: "mgl-5 mgb-3", src: featuredTag, alt: "Featured Scheme" }))))));
    };
    var handleBookmarkClick = function (e, keysForCustomFunction) {
        e.stopPropagation();
        var source = document.getElementById("bookmark-add-btn-".concat(keysForCustomFunction[0], "-").concat(keysForCustomFunction[5]));
        var target = document.getElementById("bookmarks-icon-header");
        if (!source || !target)
            return;
        var _a = calculatePositions(source, target), startX = _a.startX, startY = _a.startY, endX = _a.endX, endY = _a.endY;
        var flyingIcon = createFlyingIcon(startX, startY);
        document.body.appendChild(flyingIcon);
        requestAnimationFrame(function () {
            flyingIcon.style.transform = "translate(".concat(endX - startX, "px, ").concat(endY - startY, "px) scale(0.5)");
            flyingIcon.style.opacity = "0";
        });
        var timeoutIdForBookmark = setTimeout(function () {
            document.body.removeChild(flyingIcon);
            clearTimeout(timeoutIdForBookmark);
        }, 1500);
        props.savebookMark && props.savebookMark([keysForCustomFunction[1]]);
    };
    var calculatePositions = function (source, target) {
        var sourceRect = source.getBoundingClientRect();
        var targetRect = target.getBoundingClientRect();
        var scrollTop = window.scrollY || document.documentElement.scrollTop;
        var scrollLeft = window.scrollX || document.documentElement.scrollLeft;
        var startX = sourceRect.left + sourceRect.width / 2 + scrollLeft;
        var startY = sourceRect.top + sourceRect.height / 2 + scrollTop;
        var endX = targetRect.left + targetRect.width / 2 + scrollLeft;
        var endY = targetRect.top + scrollTop;
        return { startX: startX, startY: startY, endX: endX, endY: endY };
    };
    var createFlyingIcon = function (startX, startY) {
        var flyingIcon = document.createElement("div");
        flyingIcon.className = "flying-bookmark";
        flyingIcon.style.left = "".concat(startX, "px");
        flyingIcon.style.top = "".concat(startY, "px");
        flyingIcon.style.backgroundImage = "url(".concat(bookmarkFlyImage, ")");
        flyingIcon.style.width = "20px";
        flyingIcon.style.height = "20px";
        flyingIcon.style.position = "fixed";
        flyingIcon.style.zIndex = "9999";
        return flyingIcon;
    };
    var fundColumns = [
        {
            columnName: (React.createElement("div", { className: "d-flex align-items-center justify-content-center fund-checkbox common-checkbox-custom small-checkbox" },
                React.createElement("input", { 
                    // value={keys[0]}
                    type: "checkbox", 
                    // name={keys[1]}
                    onChange: function (e) {
                        handleSelectAllMutualFunds(e);
                    }, ref: function (e) {
                        if (!!e) {
                            e.indeterminate = e.checked
                                ? checked.length !== props.mutualFundsSchemeList.length
                                : false;
                        }
                    }, checked: !!(checked === null || checked === void 0 ? void 0 : checked.length) }))),
            keysForCustomFunction: [
                "schemeCode",
                "schemeName",
                "isin",
                "schCd",
                "category",
                "subCategory",
            ],
            // columnClassName: "text-center",
            tdCustomFunction: function (keys) {
                return (React.createElement("div", { onClick: function (e) { return e.stopPropagation(); }, className: "fund-checkbox common-checkbox-custom small-checkbox" }, (checked === null || checked === void 0 ? void 0 : checked.findIndex(function (x) { return x.schemeCode === (!!keys && keys[0]); })) !==
                    -1 ? (React.createElement("input", { value: !!keys && keys[0], type: "checkbox", name: !!keys && keys[1], onChange: function (e) {
                        var element = e.target;
                        if (element.tagName === "BUTTON") {
                            e.stopPropagation();
                        }
                        setChecked(__spreadArray(__spreadArray([], __read(checked), false), [{ schemeCode: "", schemeName: "" }], false));
                        handleCheck(e, keys);
                    }, checked: (checked === null || checked === void 0 ? void 0 : checked.findIndex(function (x) { return x.schemeCode === (!!keys && keys[0]); })) > -1 })) : checked.length >= 3 && isShowMFCompareFooter ? (React.createElement(GenericTooltip, { toolTipClassName: "desk-tooltips", placement: "top", triggerType: "hover", externalClassName: "remove-btn-props", toolTipText: "You can compare a maximum of 3 funds at a time", button: React.createElement("input", { value: !!keys && keys[0], type: "checkbox", name: !!keys && keys[1], onChange: function (e) {
                            var element = e.target;
                            if (element.tagName === "BUTTON") {
                                e.stopPropagation();
                            }
                            handleCheck(e, keys);
                        }, checked: checked.findIndex(function (x) { return (x === null || x === void 0 ? void 0 : x.schemeCode) === (!!keys && keys[0]); }) > -1, disabled: true }) })) : (React.createElement("input", { value: !!keys && keys[0], type: "checkbox", name: !!keys && keys[1], onChange: function (e) {
                        var element = e.target;
                        if (element.tagName === "BUTTON") {
                            e.stopPropagation();
                        }
                        handleCheck(e, keys);
                    }, checked: (checked === null || checked === void 0 ? void 0 : checked.findIndex(function (x) { return (x === null || x === void 0 ? void 0 : x.schemeCode) === (!!keys && keys[0]); })) > -1 }))));
            },
        },
        {
            columnName: "Scheme Name",
            key: "name",
            key3: "Name",
            sortKey: "Name",
            arrows: true,
            columnClassName: "text-end",
            applySorting: true,
            keysForCustomFunction: [
                "schemeName",
                "category",
                "subCategory",
                "schemeCode",
                "isNew",
                "isFeatured",
                "isin",
                "amcLogo",
            ],
            tdCustomFunction: function (keys) {
                return generateSchemeName(keys, this.keysForCustomFunction);
            },
        },
        {
            columnName: generateTableColumnName("Rating", "rating"),
            key: "rating",
            key3: "Rating",
            sortKey: "Rating",
            arrows: true,
            columnClassName: "text-end position-relative",
            applySorting: true,
            thId: "rating",
            tdCustomFunction: function (key) {
                return (React.createElement(React.Fragment, null, key && key !== "0" ? (React.createElement("div", { className: "star-rating RobotoM_16_500 ".concat(key === "5" ? "txt_nuvama-green" : "txt-grey-shade1", " d-flex align-items-center justify-content-end") },
                    key,
                    React.createElement("i", { className: "edel-icon-star-filled" }))) : (React.createElement("span", { className: "RobotoM_15_400" }, "-"))));
            },
        },
        {
            columnName: generateTableColumnName("1Y CAGR", "year1"),
            key: "year1",
            key3: "Year1",
            sortKey: "Year1",
            key2: "schemeCode",
            arrows: true,
            columnClassName: "text-end position-relative",
            arrowClassName: "text-right",
            thId: "year1",
            applySorting: true,
            tdCustomFunction: yearValue,
        },
        {
            columnName: generateTableColumnName("3Y CAGR", "year3"),
            key: "year3",
            key2: "schemeCode",
            key3: "Year3",
            sortKey: "Year3",
            arrows: true,
            columnClassName: "text-end position-relative",
            arrowClassName: "text-right",
            thId: "year3",
            applySorting: true,
            tdCustomFunction: yearValue,
        },
        {
            columnName: generateTableColumnName("5Y CAGR", "year5"),
            key: "year5",
            key2: "schemeCode",
            key3: "Year5",
            sortKey: "Year5",
            arrows: true,
            thId: "year5",
            applySorting: true,
            columnClassName: "text-end position-relative",
            tdCustomFunction: yearValue,
        },
        {
            columnName: generateTableColumnName("AUM", "fundSize"),
            key: "aum",
            key3: "FundSize",
            key2: "schemeCode",
            sortKey: "FundSize",
            columnClassName: "text-end position-relative",
            arrows: true,
            applySorting: true,
            thId: "fundSize",
            arrowClassName: "text-right",
            tdCustomFunction: function (key, key2) {
                var displayValue = addCommasWithoutDecimal(key);
                return (React.createElement("div", { className: "RobotoM_15_400 txt-grey-shade1" },
                    displayValue,
                    "\u00A0",
                    !isNaN(parseInt(displayValue)) && (React.createElement("span", { className: "DMSanN_15_400" }, "Cr"))));
            },
        },
        {
            columnName: generateTableColumnName("Exp. ratio", "expenseRatio"),
            key: "expenseRatio",
            key2: "schemeCode",
            key3: "ExpenseRatio",
            sortKey: "ExpenseRatio",
            arrows: true,
            applySorting: true,
            columnClassName: "text-end position-relative",
            thId: "expenseRatio",
            tdCustomFunction: function (key, key2) {
                return (React.createElement("div", { className: "RobotoM_15_400 txt-grey-shade1" }, key && Number(key) > 0
                    ? "".concat(roundUpToTwoDecimalPlaces(Number(key)), "%")
                    : "-"));
            },
        },
        {
            columnName: "Action",
            key: "",
            keysForCustomFunction: [
                "isin",
                "schCd",
                "schemeName",
                "category",
                "subCategory",
                "schemeCode",
                "isFeatured",
                "isNew",
                "schemeGroup",
                "grpCode",
                "schemePlan",
                "amcLogo",
                "isOrderAllowed",
                "isCtaAllowed",
            ],
            tdCustomFunction: function (keysForCustomFunction) {
                var _a;
                var uniqueID = "".concat(keysForCustomFunction[0], "-").concat(keysForCustomFunction[1]);
                var placeOrderNavigateState = {
                    placeOrderScheme: {
                        schemeCode: props.componentFlow === EComponentFlow.SAVED_PRODUCT
                            ? keysForCustomFunction[9]
                            : keysForCustomFunction[5],
                        schemeName: keysForCustomFunction[2],
                        catName: keysForCustomFunction[3],
                        subCatName: keysForCustomFunction[4],
                        amcLogo: null,
                        isin: keysForCustomFunction[0],
                        token: null,
                        isFeatured: keysForCustomFunction[6],
                        isNew: keysForCustomFunction[7],
                        schemeGroup: keysForCustomFunction[8],
                        categoryCode: props.categoryCode,
                        productCode: props.productCode,
                        schemeplan: keysForCustomFunction[10],
                    },
                };
                var schemedata = {
                    schemeName: keysForCustomFunction[2],
                    catName: keysForCustomFunction[3],
                    subCatName: keysForCustomFunction[4],
                    amcLogo: keysForCustomFunction[11],
                    schemeCode: keysForCustomFunction[1],
                    schemeGrp: keysForCustomFunction[8],
                    schemeplan: keysForCustomFunction[10],
                };
                var isOrderAllowed = keysForCustomFunction[12];
                var isCtaAllowed = keysForCustomFunction[13];
                return (React.createElement("div", { className: "d-flex align-items-center gap-2 table-row-action-container" },
                    isOrderAllowed ? (React.createElement(EdButton, { btnTyp: "tomato-rounded", value: "Place order", slim: true, className: "invest-button text-nowrap DMsanL_15_300", onClick: function (e) {
                            var element = e.target;
                            if (element.tagName === "BUTTON") {
                                e.stopPropagation();
                            }
                            navigate("/dashboard/place-order", {
                                state: {
                                    placeOrderNavigateState: placeOrderNavigateState,
                                    categoryCode: props.categoryCode,
                                },
                            });
                        }, hoverType: "tomato-rounded-background", disabled: checked.findIndex(function (x) { return x.isin === keysForCustomFunction[0]; }) === -1
                            ? false
                            : true })) : (React.createElement(GenericTooltip, { container: function () { return document.getElementById(uniqueID); }, placement: "bottom", triggerType: "hover", externalClassName: "primary__place__order__tooltip__container", toolTipText: React.createElement(GenericTooltipInnerContent, { tooltipTitle: React.createElement("label", { className: "d-flex flex-column gap-4" },
                                React.createElement("span", { className: "d-flex" }, "This mutual fund scheme is currently unavailable for purchase. Please explore other funds for investment."),
                                isCtaAllowed && (React.createElement("span", null, "Redeem, SWP & more actions are available in the \u2018Context menu\u2019 (three-dot)."))), hideCross: true }), noButton: true, button: React.createElement(EdButton, { btnTyp: "grey-disabled-rounded", value: "Place order", slim: true, id: uniqueID, className: "invest-button text-nowrap DMsanL_15_300" }) })),
                    ((_a = props.bookMarkData) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                        props.bookMarkData.findIndex(function (x) { return x === keysForCustomFunction[1]; }) > -1 ? (React.createElement(EdButtonIcon, { btnIcon: "edel-icon-remove-bookmark", btnTyp: "link", paths: 3, onClick: function (e) {
                            e.stopPropagation();
                            props.deleteBookMark &&
                                props.deleteBookMark([keysForCustomFunction[1]]);
                        }, className: "bg-transparent share-btn", disabled: checked.findIndex(function (x) { return x.isin === keysForCustomFunction[0]; }) === -1
                            ? false
                            : true })) : (React.createElement(EdButtonIcon, { btnIcon: "edel-icon-add-bookmark hover-blue-icon", type: "button", btnTyp: "link", onClick: function (e) { return handleBookmarkClick(e, keysForCustomFunction); }, className: "bg-transparent share-btn bookmark__add__icon ".concat(flying ? "flying" : ""), id: "bookmark-add-btn-".concat(keysForCustomFunction[0], "-").concat(keysForCustomFunction[5]), disabled: checked.findIndex(function (x) { return x.isin === keysForCustomFunction[0]; }) === -1
                            ? false
                            : true })),
                    React.createElement(EdButtonIcon, { btnIcon: "edel-icon-share-2 hover-blue-icon", btnTyp: "link", onClick: function (e) {
                            var element = e.target;
                            if (element.tagName === "I") {
                                e.stopPropagation();
                            }
                            setSharelinks([
                                qoutesMfShareUrl({
                                    isin: keysForCustomFunction[0],
                                    schemeCode: props.componentFlow === EComponentFlow.SAVED_PRODUCT
                                        ? keysForCustomFunction[5]
                                        : keysForCustomFunction[1],
                                    schemeName: keysForCustomFunction[2],
                                    subCategory: keysForCustomFunction[4],
                                }),
                            ]);
                            setshowShareModal(true);
                        }, disabled: checked.findIndex(function (x) { return x.isin === keysForCustomFunction[0]; }) === -1
                            ? false
                            : true, className: "bg-transparent share-btn" }),
                    React.createElement(GenericPopup, { children: React.createElement("div", { className: "mf-actions flex-column flexCenter" }, showCtaLoader ? (React.createElement("div", { className: "mf-action-item displayFlex hand_cursor" },
                            React.createElement(Spinner, { animation: "border", variant: "primary", className: "txt_tomatoRed" }))) : (React.createElement(React.Fragment, null, kebabMenuItems === null || kebabMenuItems === void 0 ? void 0 : kebabMenuItems.map(function (item, index) {
                            return (React.createElement("div", { role: "button", onClick: handleOnClickActionforKebabMenuItem(item.text, placeOrderNavigateState, schemedata), className: "mf-action-item displayFlex hand_cursor", key: index },
                                React.createElement("i", { className: item.icon }),
                                React.createElement("label", { className: "DMSanN_14_400 hand_cursor" }, item.text)));
                        })))), placement: "bottom-end", isShow: isin === keysForCustomFunction[0], setIsShow: function () {
                            setIsin("");
                        }, button: React.createElement("span", { id: keysForCustomFunction[0], className: "edel-icon-kabab-menu mf-row-sub-actions-container position-relative hand_cursor ".concat(isin === keysForCustomFunction[0] ? "active-menu" : "", "  ").concat(isCtaAllowed ? "" : "invisible") }), parentClass: "offerings-dropdown-container", buttonOnClick: function (e) {
                            var _a;
                            e.stopPropagation();
                            setIsin(keysForCustomFunction[0]);
                            setShowCtaLoader(true);
                            mutualFundDi.mutualFunds
                                .mFPurchaseSipCta({
                                schemeCode: keysForCustomFunction[1],
                                searchText: (_a = props === null || props === void 0 ? void 0 : props.mutualFundFilterSortValues) === null || _a === void 0 ? void 0 : _a.searchText,
                            })
                                .then(function (res) {
                                if (res.schemeCta) {
                                    setKebabMenuItems(function () {
                                        return mutualFundsActions.filter(function (item) {
                                            var _a, _b, _c, _d, _e, _f;
                                            switch (item.text) {
                                                case EProductBouquetKebabMenuItems.START_LUMPSUM:
                                                    return ((_a = res === null || res === void 0 ? void 0 : res.schemeCta[0]) === null || _a === void 0 ? void 0 : _a.purAllowed) === "Y";
                                                case EProductBouquetKebabMenuItems.START_SIP:
                                                    return ((_b = res === null || res === void 0 ? void 0 : res.schemeCta[0]) === null || _b === void 0 ? void 0 : _b.sipFlag) === "Y";
                                                case EProductBouquetKebabMenuItems.REDEEM:
                                                    return ((_c = res === null || res === void 0 ? void 0 : res.schemeCta[0]) === null || _c === void 0 ? void 0 : _c.redeemFlag) === "Y";
                                                case EProductBouquetKebabMenuItems.START_SWP:
                                                    return ((_d = res === null || res === void 0 ? void 0 : res.schemeCta[0]) === null || _d === void 0 ? void 0 : _d.swpFlag) === "Y";
                                                case EProductBouquetKebabMenuItems.START_STP:
                                                    return ((_e = res === null || res === void 0 ? void 0 : res.schemeCta[0]) === null || _e === void 0 ? void 0 : _e.stpFlag) === "Y";
                                                case EProductBouquetKebabMenuItems.SWITCH_FUND:
                                                    return ((_f = res === null || res === void 0 ? void 0 : res.schemeCta[0]) === null || _f === void 0 ? void 0 : _f.switchFlag) === "Y";
                                            }
                                        });
                                    });
                                }
                                else {
                                    setKebabMenuItems([]);
                                }
                            })
                                .catch(function (err) {
                                console.log("err", err);
                                setKebabMenuItems([]);
                            })
                                .finally(function () {
                                setShowCtaLoader(false);
                            });
                        }, containerDom: function () {
                            return document.getElementById(keysForCustomFunction[0]);
                        }, isHeadline: true, removeTooltipArrow: true })));
            },
        },
    ];
    var rowOnClick = function (element) {
        if (element === null || element === void 0 ? void 0 : element.subCategory) {
            var route = (element === null || element === void 0 ? void 0 : element.subCategory) === "Index Fund" ? "index" : "mutualfunds";
            var quoteUrl = "".concat(configUrl.quotesBase, "quotes/rm-quotes/").concat(route, "/").concat(element === null || element === void 0 ? void 0 : element.schCd, "?prefered_site=new");
            window.open(quoteUrl, "_blank");
        }
    };
    var qoutesMfShareUrl = function (element) {
        var route = (element === null || element === void 0 ? void 0 : element.subCategory) === "Index Fund" ? "index" : "mutualfunds";
        return "".concat(config.rootUrl, "quotes/").concat(route, "/").concat(element === null || element === void 0 ? void 0 : element.schemeCode);
    };
    var handleDisplayCompareFooter = function () {
        setIsShowMFCompareFooter(true);
    };
    var handleUpdateCurrentActiveColumnFilter = function (name) {
        var localStateObj = {
            currentActiveColumnFilter: name,
            filtersList: [],
        };
        switch (name) {
            case "rating":
                localStateObj.filtersList = __spreadArray([], __read(props.filterDataList.rating.list), false);
                break;
        }
        setCurrentActiveColumnFilterConfig(localStateObj);
    };
    var handleCheck = function (event, keys) {
        var _a = event.target, value = _a.value, name = _a.name;
        var updatedList = __spreadArray([], __read(checked), false);
        if (!event.target.checked) {
            setChecked(checked.filter(function (item) { return item.schemeCode !== value; }));
        }
        else {
            setChecked(__spreadArray(__spreadArray([], __read(checked), false), [
                {
                    schemeCode: event.target.value,
                    schemeName: event.target.name,
                    isin: keys === null || keys === void 0 ? void 0 : keys[2],
                    schCd: keys === null || keys === void 0 ? void 0 : keys[3],
                    category: keys === null || keys === void 0 ? void 0 : keys[4],
                    subCategory: keys === null || keys === void 0 ? void 0 : keys[5],
                },
            ], false));
        }
    };
    var handleSelectAllMutualFunds = function (e) {
        var allCheckedData = [];
        if (e.target.checked) {
            allCheckedData = props.mutualFundsSchemeList.map(function (item) {
                return {
                    schemeCode: item.schemeCode,
                    schemeName: item.schemeName,
                    isin: item.isin,
                    schCd: item.schCd,
                };
            });
        }
        setIsShowMFCompareFooter(false);
        setChecked(allCheckedData);
    };
    var handleOnClickActionforKebabMenuItem = function (item, placeOrderNavigateState, schemedata // for redeem flow only
    ) {
        return function (e) {
            e.preventDefault();
            e.stopPropagation();
            switch (item) {
                case EProductBouquetKebabMenuItems.START_LUMPSUM:
                case EProductBouquetKebabMenuItems.START_SIP:
                    navigate("/dashboard/place-order", {
                        state: {
                            placeOrderNavigateState: placeOrderNavigateState,
                            defaultInvestmentType: item.includes(EInvestmentType.LUMPSUM)
                                ? EInvestmentType.LUMPSUM
                                : EInvestmentType.SIP,
                            categoryCode: props.categoryCode,
                        },
                    });
                    break;
                case EProductBouquetKebabMenuItems.REDEEM:
                case EProductBouquetKebabMenuItems.START_STP:
                case EProductBouquetKebabMenuItems.START_SWP:
                case EProductBouquetKebabMenuItems.SWITCH_FUND:
                    setTransactionType(menuItemsToInvestmentTypeMapping[item]);
                    setSelectedSchemeData({
                        schemeName: schemedata === null || schemedata === void 0 ? void 0 : schemedata.schemeName,
                        catName: schemedata === null || schemedata === void 0 ? void 0 : schemedata.catName,
                        subCatName: schemedata === null || schemedata === void 0 ? void 0 : schemedata.subCatName,
                        amcLogo: schemedata === null || schemedata === void 0 ? void 0 : schemedata.amcLogo,
                        schemeCode: schemedata === null || schemedata === void 0 ? void 0 : schemedata.schemeCode,
                        schemeGrp: schemedata === null || schemedata === void 0 ? void 0 : schemedata.schemeGrp,
                        schemeplan: schemedata === null || schemedata === void 0 ? void 0 : schemedata.schemeplan,
                    });
                    setOpenSidebar(true);
                    break;
                default:
                    return;
            }
        };
    };
    var handleBookmarkButtonClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, isSuccessfullyDeleted, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = props === null || props === void 0 ? void 0 : props.componentFlow;
                    switch (_a) {
                        case EComponentFlow.PRODUCT_BOUQUET: return [3 /*break*/, 1];
                        case EComponentFlow.SAVED_PRODUCT: return [3 /*break*/, 2];
                    }
                    return [3 /*break*/, 5];
                case 1:
                    (props === null || props === void 0 ? void 0 : props.savebookMark) && props.savebookMark(checked.map(function (x) { return x.schCd; }));
                    return [3 /*break*/, 6];
                case 2:
                    isSuccessfullyDeleted = false;
                    _b = (props === null || props === void 0 ? void 0 : props.deleteBookMark);
                    if (!_b) return [3 /*break*/, 4];
                    return [4 /*yield*/, props.deleteBookMark(checked.map(function (x) { return x.schCd; }))];
                case 3:
                    _b = (isSuccessfullyDeleted = _c.sent());
                    _c.label = 4;
                case 4:
                    _b;
                    if (isSuccessfullyDeleted) {
                        setChecked([]);
                    }
                    return [3 /*break*/, 6];
                case 5: return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleCalculateSchemeNameMaxWidth = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        // TODO: This function needs to be refactored more for more proper functionlity
        try {
            if (((_b = (_a = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _a === void 0 ? void 0 : _a.rows) === null || _b === void 0 ? void 0 : _b.length) && ((_c = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _c === void 0 ? void 0 : _c.rows[0].cells)) {
                var totalOccupiedWidthExceptSchemeColumn_1 = (_e = Array.from((_d = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _d === void 0 ? void 0 : _d.rows[0].cells)) === null || _e === void 0 ? void 0 : _e.reduce(function (sum, cell, index) {
                    if (index !== 1) {
                        return sum + cell.offsetWidth;
                    }
                    return sum;
                }, 0);
                var thead = tableRef.current.querySelector("thead");
                var tbody = tableRef.current.querySelector("tbody");
                if (thead) {
                    var secondTh = thead.querySelectorAll("th")[1]; // 0-based index
                    if (secondTh) {
                        secondTh.style.maxWidth = "".concat(((_g = (_f = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _f === void 0 ? void 0 : _f.parentElement) === null || _g === void 0 ? void 0 : _g.clientWidth) -
                            totalOccupiedWidthExceptSchemeColumn_1 -
                            10, "px");
                    }
                }
                if (tbody) {
                    tbody.querySelectorAll("tr").forEach(function (row) {
                        var _a, _b;
                        var secondTd = row.querySelectorAll("td")[1];
                        if (secondTd) {
                            secondTd.style.maxWidth = "".concat(((_b = (_a = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.clientWidth) -
                                totalOccupiedWidthExceptSchemeColumn_1 -
                                10, "px");
                        }
                    });
                }
            }
        }
        catch (_h) { }
    };
    React.useEffect(function () {
        handleCalculateSchemeNameMaxWidth();
    }, [props === null || props === void 0 ? void 0 : props.mutualFundsSchemeList]);
    return (React.createElement(React.Fragment, null,
        (checked === null || checked === void 0 ? void 0 : checked.length) > 0 ? (React.createElement(OfferingsTableCheckboxActions, { selectedDataForComparison: checked, compareButtonCallback: handleDisplayCompareFooter, bookmarkButtonCallback: handleBookmarkButtonClick, 
            // shareButtonCallback={() => { // hide for now
            //   setSharelinks(
            //     checked.map((z) => {
            //       return qoutesMfShareUrl(z);
            //     })
            //   );
            //   setshowShareModal(true);
            // }}
            bookmarkButtonText: props === null || props === void 0 ? void 0 : props.saveButtonText })) : (React.createElement(React.Fragment, null)),
        props.loader && (React.createElement(GenericTableShimmer, { rowCount: 10, columnCount: 8, columnsWidthClass: "table-shimmer-col-fr2-1-1-1-1-1-1-1_2" })),
        ((_a = props === null || props === void 0 ? void 0 : props.mutualFundsSchemeList) === null || _a === void 0 ? void 0 : _a.length) > 0 && (React.createElement(DynamicPagination, { dataLengthPerPage: props.dataLengthPerPage || 10, data: props.mutualFundsSchemeList, Bodycomponent: GenericTable, rowOnClick: rowOnClick, rowClassName: function (ele) {
                return checked.findIndex(function (x) { return x.schemeCode === ele.schemeCode; }) ===
                    -1
                    ? ""
                    : "bg_aqua_white";
            }, columns: fundColumns, tableRef: tableRef, 
            // disableMemoization
            parentClassName: "top-performing common-compact-table-wrapper ".concat(props.viewAll && "viewAll", " primary-offerings-table-wrapper"), infinityScroll: true, manualNext: props.viewAll ? props.totalPages > props.page + 1 : false, nextFunction: props.viewAll ? props.nextPage : undefined, totalNumberPages: props.viewAll ? props.totalPages : undefined, paginationLoader: props.loader, initPageNumber: props.viewAll ? props.page + 1 : undefined, callbackSorted: onSortToggleClick, selectedSortColumnVal: ((_b = props === null || props === void 0 ? void 0 : props.mutualFundFilterSortValues) === null || _b === void 0 ? void 0 : _b.sortColumn) === "NameDSC"
                ? "Name"
                : (_c = props === null || props === void 0 ? void 0 : props.mutualFundFilterSortValues) === null || _c === void 0 ? void 0 : _c.sortColumn, selectedSortVal: (_d = props === null || props === void 0 ? void 0 : props.mutualFundFilterSortValues) === null || _d === void 0 ? void 0 : _d.sortOrder, sortIconUp: "edel-icon-arrow-up-thin", sortIconDown: "edel-icon-arrow-down", viewAll: props.viewAll, isPageFromParent: true })),
        isShowMFCompareFooter && (React.createElement(OfferingsComparison, { checked: checked, setChecked: setChecked, page: "mutualFunds", currentItem: currentItem, setCurrentItem: setCurrentItem, isMarketPage: true, redirectionUrl: location.href, paramsData: props === null || props === void 0 ? void 0 : props.paramsData, addMore: function () {
                setSearchPop(true);
            }, close: function () {
                setIsShowMFCompareFooter(false);
            } })),
        searchPop && (React.createElement(Search, { searchPopup: searchPop, setSearchPopup: setSearchPop, 
            // setShowToc={true}
            // setSymbol={setSymbol}
            // setType={setType}
            // setSchemeCode={setSchemeCode}
            defaultActiveTab: SearchAssetTypeEnum.MF, setSearchData: function (data) {
                setChecked(function (checkData) { return __spreadArray(__spreadArray([], __read(checkData), false), [
                    {
                        schemeCode: data.mfSchemeCode,
                        schemeName: data.mfName,
                        isin: data.isin,
                        schCd: data.schemeCode,
                        category: data.categoryName.toString(),
                        subCategory: data.subCategoryName,
                    },
                ], false); });
            }, sourceCustomClass: "mf-compare-search-bar", placeholder: "Search for a fund", hideTabs: true, placeOrder: true })),
        showShareModal && (React.createElement(ShareSocialLinks, { setShare: setshowShareModal, value: sharelinks.join("\n") })),
        React.createElement(RedeemSidebarFlow, { openSidebar: openSidebar, setOpenSidebar: setOpenSidebar, selectedSchemeData: selectedSchemeData, transactionType: transactionType })));
};
export default TopFundsTableDesk;
